import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { savePreset } from '@api/kpi';

import { ISavePresetDTO, TCreatePresetFncDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes } from '@enums/common';

import { CREATE_PRESET, PRESET_OPTIONS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSavePreset = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: createPreset,
		isLoading: isLoadingCreatePreset,
	} = useMutation<TCreatePresetFncDTO>({
		mutationKey: [CREATE_PRESET],
		mutationFn: ({ data, closePresetForm }: {
			data: ISavePresetDTO;
			closePresetForm: () => void;
		}) => savePreset(data)
			.then(() => {
				closePresetForm();
			}),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.createPreset,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([PRESET_OPTIONS]);
		},
	});

	return {
		createPreset,
		isLoadingCreatePreset,
	};
};
